import { type HTMLAttributes } from "react";

type Props = HTMLAttributes<HTMLButtonElement>;

export default function SaveIconActive(props: Props) {
  return (
    <button {...props}>
      <svg
        width="15"
        height="18"
        viewBox="0 0 15 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.093 0.323524C14.193 0.451524 15 1.40052 15 2.50852V18.0015L7.5 14.2515L0 18.0015V2.50852C0 1.40052 0.806 0.451524 1.907 0.323524C5.62319 -0.107841 9.37681 -0.107841 13.093 0.323524Z"
          fill="#E73545"
        />
      </svg>
    </button>
  );
}
